import { render, staticRenderFns } from "./firm.vue?vue&type=template&id=efc690ba&scoped=true&"
import script from "./firm.vue?vue&type=script&lang=js&"
export * from "./firm.vue?vue&type=script&lang=js&"
import style0 from "./firm.vue?vue&type=style&index=0&id=efc690ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc690ba",
  null
  
)

export default component.exports